<div class="column user-profile-actions">
	<div class="row-center font-small-turquoise">
		<span class="tos-policy__group">
			@if (showAgreeText) {
				<span
					id="agree-to-the-terms-of-use"
					class="font-small-gray font-weight-light spacing-small"
					i18n="@@termsAndPolicy-agreeToThe"
				>
					I agree to the
				</span>
			}
			<span i18n="@@termsAndPolicy-nonUS"> Non-US </span>
			<span class="font-weight-light"> | </span>
			<a
				[href]="nonUsPrivacyPolicyUrl"
				appExternalLink
				i18n="@@termsAndPolicy-privacyPolicy"
				data-automation-id="privacy-policy-link"
				>Privacy Policy</a
			>
			<span class="font-small-gray font-weight-light spacing-small"> & </span>
			<a
				[href]="nonUsTermsOfServiceUrl"
				appExternalLink
				i18n="@@termsAndPolicy-TermsOfService"
				data-automation-id="tos-link"
			>
				Terms of Service
			</a>
		</span>
	</div>

	<div class="row-center font-small-turquoise">
		<span class="tos-policy__group">
			<span i18n="@@termsAndPolicy-US"> US </span>
			<span class="font-weight-light"> | </span>
			<a
				[href]="usPrivacyPolicyUrl"
				appExternalLink
				i18n="@@termsAndPolicy-privacyPolicy"
				data-automation-id="privacy-policy-link"
				>Privacy Policy</a
			>
			<span class="font-small-gray font-weight-light spacing-small"> & </span>
			<a
				[href]="usEndUserLicenseAgreementUrl"
				appExternalLink
				i18n="@@termsAndPolicy-EndUserLicenseAgreement"
				data-automation-id="tos-link"
			>
				End User License Agreement
			</a>
			@if (showAgreeText) {
				<span class="font-small-gray font-weight-light spacing-small">.</span>
			}
		</span>
	</div>
</div>
